import styled from 'styled-components'

import { Col } from '@yes.technology/react-toolkit'

export const StyledCol = styled(Col)`
  & > div {
    height: 100%;
  }
`
